import { http } from "@/main";
import { handleRequest } from "..";
import {
  ResetPasswordParams,
  SendResetPasswordEmailParams,
} from "@/types/validator";

export const sendResetPasswordEmailApi = async (
  params: SendResetPasswordEmailParams
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    http.post("/manager/sendResetPasswordEmail", params),
    (response) => response.data.result
  );
};

export const resetPasswordApi = async (
  params: ResetPasswordParams
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    http.post("/manager/resetPassword", params),
    (response) => response.data.result
  );
};

export const checkResetPasswordIdApi = async (
  id: string
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    http.get("/manager/checkResetPasswordId", { params: { id: id } }),
    (response) => response.data.result
  );
};
